export default {
  RAW_CONTENT_FETCHED: 'RAW_CONTENT_FETCHED',
  RAW_CONTENT_LOAD: 'RAW_CONTENT_LOAD',
  RAW_CONTENT_TEMPLATES_FETCHED: 'RAW_CONTENT_TEMPLATES_FETCHED',
  RAW_CONTENT_TEMPLATES_LOAD: 'RAW_CONTENT_TEMPLATES_LOAD',
  RAW_CONTENT_DETAIL: 'RAW_CONTENT_DETAIL',
  RAW_CONTENT_BUTTON_LOAD: 'RAW_CONTENT_BUTTON_LOAD',
};
